<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Incidencia" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="issue" >
			<div style="width: 100%;">
				<div class="mb-4">
					<strong>Prioridad </strong><b-badge :variant="getPriorityColor(issue.issuePriority.id)">{{issue.issuePriority.name}}</b-badge>
					<strong>Estado </strong><status-badge :status="issue.statuses[0]"/>
					<p class="mt-2">{{`Creada el ${getHumanDateAndTime(issue.createdAt)}`}}</p>
					<p class="mt-2" v-if="issue.resolveBy">{{`Resolver para el ${getHumanDate(issue.resolveBy)}`}}</p>
				</div>

				<div class="mb-4" v-if="!school">
					<h2>Colegio</h2>
					<p>{{issue.school.name}}</p>
				</div>

				<div class="mb-4">
					<h2>Creador</h2>
					<p>{{getPersonFullName(issue.personCreated)}}</p>
				</div>

				<div class="mb-4">
					<h2>Título</h2>
					<table class="table table-sm table-striped">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="1" type="text" v-model="issue.title" :disabled="true"/></td>
						</tr>
					</table>
				</div>

				<div class="mb-4">
					<h2>Descripción</h2>
					<table class="table table-sm table-striped">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="5" type="text" v-model="issue.description" :disabled="true"/></td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['issueId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		issue () {
			return this.$store.state.admin.issue;
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		getPriorityColor (priorityId) {
			if (priorityId == '1') return 'danger';
			if (priorityId == '2') return 'warning';
			if (priorityId == '4') return 'success';
			if (priorityId == '3') return 'primary';
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/IssueDetail.vue